import { init } from '@ori/analytics-provider';
import { ApplicationInsights, getClientApplicationInsightsConfig, Logger } from '@ori/logger';
import { initUserActionEvents } from './initUserActionEvents';
function getDataFromElement() {
  const dataElement = document.getElementById('analytics-provider-data');
  if (!dataElement?.innerHTML) {
    throw new Error("Analytics provider configuration wasn't set properly.");
  }
  const data = dataElement.innerHTML;

  // Client app supports only GTM for now.
  return {
    gtm: JSON.parse(data)
  };
}
const clientAppConfig = getDataFromElement();
if (process.env.NODE_ENV === 'production') {
  ApplicationInsights.initialize(getClientApplicationInsightsConfig());
}
Logger.updateGlobalMetadata({});
init(clientAppConfig);

// TODO: Vlada Holan is checking whether this is still needed, because we use it only in Online for 3 user-action events "steps_to_success", "Go to the perfect start"; "steps_to_success", "Skip to dashboard"; "steps_to_success", "Save & Share button".
// TODO: Other events using this approach are not consumed by GTM.
// TODO: This is used in Online only, https://oriflame.visualstudio.com/Online/_search?action=contents&type=code&text=ref%3AGetDataAttributeForOriEventsUserAction, remove once "Steps to success" is migrated to ASMS.
initUserActionEvents();